import React from "react";
import { connect } from "react-redux";
import language from "../../../language";
import { Table } from "../../Table";
import { Modal, DeleteModal } from "../../Modal";
import { CSVLink } from "react-csv";
import { getStorage } from "../../../utils/storage";
import icons from "../../../constants/icons";
import moment from "moment";
import {
  fetchSerologyResult,
  deleteSerologyResult,
  pushSerologyResult,
  bulkRetrySerologyResult,
} from "../../../utils/queries/serologyResult";

class SerologyAlinity extends React.Component {
  csvDownload = React.createRef();

  state = {
    isLoading: false,
    isPushing: false,
    isBulkRetrying: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selectedData: {},
    totalPageCount: 10,
    delete_password: "",
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
    filters: {
      startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    },
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });

    await this.fetchData(true, this.state.filters);
  };

  buildNextFilters = (params = {}) => {
    const nextFilters = {
      ...this.state.filters,
      ...params,
    };

    const searchableFields = ["sampleId", "messageId", "tester", "result"];

    searchableFields.forEach((field) => {
      if (
        Object.prototype.hasOwnProperty.call(params, field) &&
        !params[field]
      ) {
        delete nextFilters[field];
      }
    });

    return nextFilters;
  };

  fetchData = async (isLoading, params = {}) => {
    const nextFilters = this.buildNextFilters(params);

    this.setState(
      {
        filters: nextFilters,
        page: 1,
      },
      () => this.getData(isLoading, nextFilters),
    );
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({ error, [field]: e?.target?.value });
  }

  getData = async (isLoading, search = {}) => {
    try {
      const { page, limit } = this.state;
      const { defaultLanguage } = this.props;
      const filters = this.buildNextFilters(search);

      this.setState({
        isLoading,
        filters,
      });

      const { data, count, totalRecords } = await fetchSerologyResult(defaultLanguage, {
        page,
        limit,
        ...filters,
      });

      this.setState({
        data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true);
      },
    );
  }

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].sample_id,
        key: "sampleId",
        type: "link",
        onPress: (item) =>
          this.handleShowModal("showModal", item.sampleId, item),
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].tester,
        key: "tester",
      },
      {
        title: language[this.props.defaultLanguage].created_at,
        key: "createdAt",
        isMoment: true,
        inputFormat: "YYYY-MM-DDTHH:mm:ss.SSSZ",
        formatTime: "lll",
      },
      {
        title: "Status",
        key: "status",
        type: "status",

      },
      {
        title: language[this.props.defaultLanguage].reason,
        key: "statusReason",
        // Against a failed row only. The reason stays in the database
        // once the message is attached - a donation registered days late
        // leaves a trace of why its results waited - but a row that is
        // through is not something the screen needs to explain.
        render: (item) =>
          item.status === "failed" && item.statusReason ? (
            <span title={item.statusReason}>{item.statusReason}</span>
          ) : (
            "-"
          ),
      },
    ].filter(Boolean);

    return headers;
  }

  onPush = async () => {
    try {
      this.setState({ isPushing: true });

      await pushSerologyResult(
        this.props.defaultLanguage,
        this.state.selectedData._id,
      );

      this.setState({ isPushing: false });
      this.handleCloseModal("showModal");
      this.getData(true);
    } catch (error) {
      this.setState({ isPushing: false });
    }
  };

  onBulkRetry = async () => {
    try {
      this.setState({ isBulkRetrying: true });
      await bulkRetrySerologyResult(this.props.defaultLanguage);
      this.setState({ isBulkRetrying: false });
      this.getData(true);
    } catch (error) {
      this.setState({ isBulkRetrying: false });
    }
  };

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deleteSerologyResult(
        this.props.defaultLanguage,
        this.state.selectedData._id,
      );

      this.setState({ isDeleting: false });

      this.getData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      console.log(error);
      this.setState({
        isDeleting: false,
      });
    }
  };

  handleRemoteSearch = async (search) => {
    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));

    await this.fetchData(true, {
      sampleId: search && search.trim() ? search.trim() : undefined,
    });

    this.setState({
      searching: false,
    });
  };

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  handleResultFilter = (value) => {
    this.fetchData(true, { result: value || undefined });
  };

  renderItem = (label, value, type, inputFormat) => {
    return (
      <div
        style={{
          display: "flex",
          minHeight: "35px",
          alignItems: "center",
          borderBottom: "1px solid #ddd",
        }}
      >
        <div style={{ flex: 1 }}>
          <p>{label}:</p>
        </div>
        <div>
          <p>
            <b>
              {value && type === "date"
                ? inputFormat
                  ? moment(value, inputFormat).format("DD/MM/YYYY HH:mm")
                  : moment(value).format("DD/MM/YYYY HH:mm")
                : value}
            </b>
          </p>
        </div>
      </div>
    );
  };

  render() {
    return (
      <>
        <Table
          data={this.state.data}
          fetchData={(isLoading, search) => this.fetchData(isLoading, search)}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          addSearchButton
          searching={this.state.searching}
          handleSearch={this.handleSearch.bind(this)}
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          rowPress={(item) =>
            this.handleShowModal("showModal", item.sampleId, item)
          }
          filters={[
            {
              type: "dropdown",
              filterName: "date_range",
              title: language[this.props.defaultLanguage].date_range,
              button_type: "dropdown",
              startDate: this.state.filters.startDate,
              endDate: this.state.filters.endDate,
            },
            {
              type: "dropdown",
              filterName: "result",
              title: language[this.props.defaultLanguage].result,
              button_type: "dropdown",
              icon: "filter_alt",
              options: [
                {
                  label: "All",
                  value: "",
                  onPress: () => this.handleResultFilter(""),
                },
                {
                  label: "Nonreactive",
                  value: "Nonreactive",
                  onPress: () => this.handleResultFilter("Nonreactive"),
                },
                {
                  label: "Reactive",
                  value: "Reactive",
                  onPress: () => this.handleResultFilter("Reactive"),
                },
              ],
            },
            {
              type: "button",
              title: language[this.props.defaultLanguage].refresh,
              button_type: "button",
              icon: icons.refresh,
              onPress: () => this.fetchData(true, this.state.filters),
            },
            {
              type: "button",
              title: this.state.isBulkRetrying ? "Retrying..." : "Bulk Retry Failed",
              button_type: "button",
              icon: icons.refresh,
              onPress: this.onBulkRetry,
              disabled: this.state.isBulkRetrying,
              className: "btn-danger",
            },
          ]}

        />

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
        >
          {this.state.selectedData && (
            <div className="card-body">
              {this.renderItem(
                language[this.props.defaultLanguage].sample_id,
                this.state.selectedData.sampleId,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].patient_id,
                this.state.selectedData.patientId,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].message_id,
                this.state.selectedData.messageId,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].analyzer,
                this.state.selectedData.analyzer,
              )}

              {/* Show all test results from results[] array */}
              {Array.isArray(this.state.selectedData.results) &&
                this.state.selectedData.results.length > 0 && (
                  <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                    <h6 style={{ borderBottom: "1px solid #ddd", paddingBottom: "0.5rem" }}>
                      Test Results
                    </h6>
                    {this.state.selectedData.results.map((r, idx) => (
                      <div
                        key={idx}
                        style={{
                          background: "#f8f9fa",
                          padding: "0.75rem",
                          marginBottom: "0.5rem",
                          borderRadius: "4px",
                          border: "1px solid #eee",
                        }}
                      >
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
                          <div style={{ flex: "1", minWidth: "200px" }}>
                            <small style={{ color: "#666" }}>Test</small>
                            <p style={{ margin: 0, fontWeight: 500 }}>{r.testName || r.testCode || "-"}</p>
                          </div>
                          <div style={{ flex: "1", minWidth: "120px" }}>
                            <small style={{ color: "#666" }}>Result</small>
                            <p style={{ margin: 0, fontWeight: 500 }}>{r.result || "-"}</p>
                          </div>
                          {r.sCoRatio != null && (
                            <div style={{ flex: "1", minWidth: "100px" }}>
                              <small style={{ color: "#666" }}>S/Co Ratio</small>
                              <p style={{ margin: 0, fontWeight: 500 }}>{r.sCoRatio}</p>
                            </div>
                          )}
                          {r.assayRole && r.assayRole !== "unknown" && (
                            <div style={{ flex: "1", minWidth: "120px" }}>
                              <small style={{ color: "#666" }}>Assay Role</small>
                              <p style={{ margin: 0, fontWeight: 500, textTransform: "capitalize" }}>
                                {r.assayRole.replace(/_/g, " ")}
                              </p>
                            </div>
                          )}
                          {r.stage && r.stage !== "unknown" && (
                            <div style={{ flex: "1", minWidth: "120px" }}>
                              <small style={{ color: "#666" }}>Stage</small>
                              <p style={{ margin: 0, fontWeight: 500, textTransform: "capitalize" }}>
                                {r.stage.replace(/_/g, " ")}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

              {/* Fallback for legacy single-test flat fields when results[] is empty */}
              {(!Array.isArray(this.state.selectedData.results) ||
                this.state.selectedData.results.length === 0) && (
                <>
                  {this.renderItem(
                    language[this.props.defaultLanguage].test_name,
                    this.state.selectedData.testName,
                  )}
                  {this.renderItem(
                    language[this.props.defaultLanguage].test_code,
                    this.state.selectedData.testCode,
                  )}
                  {this.renderItem(
                    language[this.props.defaultLanguage].result,
                    this.state.selectedData.result,
                  )}
                  {this.renderItem(
                    language[this.props.defaultLanguage].s_co_ratio,
                    this.state.selectedData.sCoRatio,
                  )}
                </>
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].tester,
                this.state.selectedData.tester,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].department,
                this.state.selectedData.department,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].rack_id,
                this.state.selectedData.rackId,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].position,
                this.state.selectedData.position,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].module,
                this.state.selectedData.module,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].instrument_id,
                this.state.selectedData.instrumentId,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].manufacturer,
                this.state.selectedData.manufacturer,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].sender_application,
                this.state.selectedData.senderApplication,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].sender_facility,
                this.state.selectedData.senderFacility,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].receiver_application,
                this.state.selectedData.receiverApplication,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].receiver_facility,
                this.state.selectedData.receiverFacility,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].raw_signal,
                this.state.selectedData.rawSupplementalSignal,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].signal_unit,
                this.state.selectedData.signalUnit,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].supplemental_id,
                this.state.selectedData.supplementalId,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].calibration_lot,
                this.state.selectedData.calibrationLot,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].calibration_expiry,
                this.state.selectedData.calibrationExpiry,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].reagent_lot,
                this.state.selectedData.singleTestReagentLot,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].reagent_expiry,
                this.state.selectedData.singleTestReagentExpiry,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].created_at,
                this.state.selectedData.createdAt,
                "date",
              )}

              {this.renderItem(
                language[this.props.defaultLanguage].timestamp,
                this.state.selectedData.timestamp,
                "date",
              )}

              {this.state.selectedData.status === "failed" &&
                this.state.selectedData.statusReason &&
                this.renderItem(
                  language[this.props.defaultLanguage].reason,
                  this.state.selectedData.statusReason,
                )}

              {["pending", "failed"].includes(this.state.selectedData.status) && (
                <div style={{ marginTop: "1rem", textAlign: "right" }}>
                  <button
                    className="btn btn-primary"
                    onClick={this.onPush.bind(this)}
                    disabled={this.state.isPushing}
                  >
                    {this.state.isPushing ? (
                      <>Pushing...</>
                    ) : (
                      <>Push</>
                    )}
                  </button>
                </div>
              )}
            </div>
          )}
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal",
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state.selectedData.name}
            getData={this.getData.bind(this)}
          />
        </Modal>
        <CSVLink
          ref={this.csvDownload}
          filename={"Alinity-Results-" + new Date().getTime()}
          data={this.state.csvData}
        ></CSVLink>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(SerologyAlinity);
